export class CommonSearch {
  SearchType: string;
  SearchQuery: string;
  Searchstring: string;
  Status: string;
  Message: string;
  Code: string;


}

export enum Role {
  Administrator = "1",
  Tier2 = "2",
  ReadOnly = "3"
}

export enum SubscriptionModule {
  PayrollCheckHQ = "Payroll - CheckHQ",
  Procurement2 = "Procurement 2.0",
  ProcurementTableHeader = "Pro 2.0"
}



// WEBPACK FOOTER //
// ./src/app/Classes/CommonClass.ts